import { HttpErrorResponse, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { catchError, tap, throwError } from "rxjs";
import { ToastrService } from 'ngx-toastr';
import { inject } from "@angular/core";

export function errorInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
    const toastr = inject(ToastrService);

    return next(req).pipe(
        catchError((error) => {
            if(error instanceof HttpErrorResponse && error.status != 401) {
                if(error.error.detail) {
                    toastr.error(error.error.detail,'', {
                        timeOut: 5000,
                        positionClass: 'toast-top-right',
                    });
                }
                else {
                    toastr.error('Si è verificato un errore','', {
                        timeOut: 5000,
                        positionClass: 'toast-top-right',
                    });
                }
            }
            return throwError(() => error);
        })
    )
}